<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <div *ngIf="isLoggedIn">
        <fuse-vertical-navigation class="bg-[#292929] text-white print:hidden" [mode]="'over'" [name]="'mainNavigation'"
            [navigation]="navigation.defaultLogin" [opened]="false">
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationContentHeader>
                <!-- Logo -->
                <div class="flex flex-row items-center h-8 py-24 px-8">
                    <img class="w-full" src="assets/CellC_Assets/cell-c-logo.svg" alt="Logo image">
                </div>

            </ng-container>
            <ng-container fuseVerticalNavigationContentFooter>
                <!-- Log in-out -->
                <div class="flex items-center justify-start w-full mt-12 p-4">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75" />
                    </svg>
                    <button mat-button class="bg-primary text-black rounded-full mx-2 Poppins"
                        (click)="signOut()">
                        <a class="font-bold ">Log out</a>
                    </button>
                </div>
            </ng-container>
        </fuse-vertical-navigation>
    </div>

    <div *ngIf="!isLoggedIn">
        <fuse-vertical-navigation class="bg-[#292929] text-white print:hidden" [mode]="'over'" [name]="'mainNavigation'"
            [navigation]="navigation?.default" [opened]="false">
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationContentHeader>
                <!-- Logo -->
                <div class="flex flex-row items-center h-8 py-24 px-8">
                    <img class="w-full" src="assets/CellC_Assets/cell-c-logo.svg" alt="Logo image">
                </div>
            </ng-container>
            <ng-container fuseVerticalNavigationContentFooter>
                <!-- Log in-out -->
                <div class="flex col-span-1 justify-start items-center mx-7 mt-10 bottom-0">
                    <!-- <mat-icon color="primary" [svgIcon]="'heroicons_outline:arrow-left-end-on-rectangle'"></mat-icon> -->
                    <button mat-button class="bg-primary text-black px-6 font-bold rounded-full" [routerLink]="['/sign-in']" (click)="onLoginClick('Log In')">
                        Log In
                    </button>
                </div>
            </ng-container>
        </fuse-vertical-navigation>
    </div>
</ng-container>
<!-- Wrapper -->
<div class="flex-col flex-auto items-center w-full min-w-0 dark:bg-card">
    <!-- Header -->
    <div class="relative flex flex-col flex-0 justify-center w-full overflow-hidden z-49 shadow dark:shadow-none print:hidden">
        <!-- Top bar -->
        <div class="relative dark justify-center w-full px-4 md:px-8 md:py bg-black dark:bg-gray-900">
            <div class="flex items-center w-full sm:h-20 justify-between Poppins">
                <!-- Navbar - User not logged in & Screen Small -->
                <ng-container *ngIf="!isScreenSmall && !isLoggedIn">
                    <!-- Logo -->
                    <div class="flex flex-row items-center h-20 py-8 px-15 w-full">
                        <img class="w-32 cursor-pointer" src="assets/CellC_Assets/cell-c-logo.svg" alt="Logo image" [routerLink]='["home"]'>
                    </div>
                    <div class="flex justify-end mt-2">        
                        <button class="bg-[#EA5B0C] rounded-full font-semibold py-2 px-5 h-fit transition ease-in-out hover:bg-[#ea5a0ce1] duration-300" [routerLink]='["sign-in"]' (click)="onLoginClick('Login')">
                            <span class="text-black font-normal">
                                Login
                            </span>
                        </button>
                        <div class="py-2 px-3">
                            <h1 class="w-20">
                                <h1 [ngClass]="contactUsSelected ? 'isActive' : 'isInactive' " class="cursorPointer Poppins underline" (click)="goToContactUs()">Contact us</h1>
                            </h1>
                        </div>
                        <div class="py-2 px-3 mr-2 w-12">
                            <!-- <mat-icon class="icon-white" svgIcon="heroicons_solid:shopping-cart"></mat-icon> -->
                             <img class="text-white cursor-pointer" src="assets/CellC_Assets/cart_shopping.svg" alt="" [routerLink]="['cart']">
                        </div>
                    </div>
                </ng-container>

                <!-- Navbar - User logged in & Screen Small -->
                <ng-container *ngIf="!isScreenSmall && isLoggedIn">
                    <!-- Logo -->
                     <div class="w-full flex flex-row justify-between Poppins">
                        <div class="flex order-1 justify-start items-center h-20 py-8 px-15">
                            <img class="w-32 cursor-pointer" src="assets/CellC_Assets/cell-c-logo.svg" alt="Logo image" [routerLink]='["home"]'>
                        </div>
                        <div class="flex flex-row order-2 items-center space-x-6 pr-10 font-medium"> 
                            <div class="h-full flex items-center" [ngClass]="activePage === 'Dashboard' ? 'isActive' : 'isInactive'">
                                <h1 class="cursor-pointer h-full flex items-center"  (click)="goToDashboard()">My account</h1>
                            </div>       

                            
                            <div class="flex flex-row justify-center items-center h-full">

                                <div class="h-full flex items-center" [ngClass]="activePage === 'Cart' ? 'isActive' : 'isInactive'">
                                    <h1 class="cursor-pointer"   (click)="goToCart()">My cart</h1>
                                    <div *ngIf="cartItems?.length > 0" class="bg-[#D3520B] rounded-full w-7 h-7 ml-2 my-1">
                                        <p class="text-black font-bold text-md flex justify-center items-center font-center py-1">{{cartItems?.length}}</p>
                                    </div>
                                </div>

                            </div>
                            <h1 [ngClass]="contactUsSelected ? 'isActive' : 'isInactive' " class="cursorPointer underline" (click)="goToContactUs()">Contact us</h1>
                        </div>

                        <div class="order-3 flex flex-row items-center">
                            <div class="flex flex-row py-2 px-4 bg-[#292929] rounded-full transition ease-in-out hover:-translate-y-1 hover:scale-105 duration-300 hover:cursor-pointer"  (click)="goToDashboard()"> 
                                <img src="/assets/CellC_Assets/logged-in.svg" alt="logged-in" class="pr-1">
                                <h1 class="flex items-center font-medium Poppins">Welcome</h1>
                            </div>

                            <div class="flex flex-row py-2 px-4 bg-black hover:bg-[#292929] text-primary outline outline-2 outline-primary
                                        rounded-full ml-2 cursor-pointer transition ease-in-out hover:-translate-y-1 hover:scale-105 duration-300" [routerLink]="['/sign-out']">
                                <h1 class="font-medium Poppins">Log out</h1>
                            </div>

                        </div>
                     </div>
                </ng-container>


                <!-- Navigation toggle button -->
                <ng-container *ngIf="isScreenSmall && isLoggedIn">
                    <div class="w-full flex items-center justify-between px-2 Poppins">
                        <button
                                mat-icon-button
                                (click)="toggleNavigation('mainNavigation')">
                            <mat-icon class="text-white" [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                        </button>

                        <img [routerLink]="['/home']" class="w-18 h-18 -my-2 hover:cursor-pointer" src="assets/CellC_Assets/cell-c-logo.svg"  alt="">

                        <img [routerLink]="['/dashboard']" class="w-8 h-8 hover:cursor-pointer" src="/assets/CellC_Assets/logged-in.svg" alt="">


                    </div>
                    
                </ng-container>


                <!-- Navigation toggle button -->
                <ng-container *ngIf="isScreenSmall && !isLoggedIn">
                    <div class="relative w-full flex items-center justify-between px-2 Poppins">
                        <button
                                mat-icon-button
                                (click)="toggleNavigation('mainNavigation')">
                            <mat-icon class="text-white" [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                        </button>

                        <img [routerLink]="['/home']" class="absolute left-1/2 -translate-x-1/2 w-18 h-18 -my-2 hover:cursor-pointer pointer-events-auto" src="assets/CellC_Assets/cell-c-logo.svg" alt="Cell C">

                        <div class="w-12 shrink-0" aria-hidden="true"></div>
                    </div>
                </ng-container>
                <!-- Components -->
                <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
                    <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen> -->
                    <!-- <search [appearance]="'bar'"></search> -->
                    <!-- <button
                        class="lg:hidden"
                        mat-icon-button
                        (click)="quickChat.toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
                    </button> -->
                </div>
            </div>
        </div>
        <!-- Menu bar -->
        <!-- <ng-container *ngIf="!isScreenSmall">
            <div class="flex flex-auto px-4 md:px-8 bg-card bg-primary-500 dark:bg-gray-700 text-white py-4">
                <div class="items-center w-full max-w-full px-10">
                    <fuse-horizontal-navigation [name]="'mainNavigation'" [navigation]="navigation.horizontalLoggedIn">
                        
                      </fuse-horizontal-navigation>
                </div> -->
                <!-- <button  class="yellow-button bg-accent-500 text-brown-600 hover:bg-secondary-600 font-bold py-2 px-6">
                    Check Coverage
                </button> -->
            <!-- </div>
        </ng-container> -->
    </div>

    <!-- Content -->
    <div class="flex-auto justify-center w-full overflow-hidden">
        <router-outlet *ngIf="true"></router-outlet>
    </div>


  <app-footer *ngIf="shouldShowFooter()"></app-footer>

</div>

